"use client";

import { defaultAssetTypes } from "../../schema";
import { fetchAssetSearch } from "./fetchers";
import { useAsyncData } from "./useAsyncData";

const DEFAULT_LIMIT_PER_TYPE = 5;

/** Left off, the request is unchanged from before the type existed. */
export function useAssetSearch(
  query: string,
  limitPerType = DEFAULT_LIMIT_PER_TYPE,
  includeNextGenZaps = false,
) {
  return useAsyncData(
    [query, limitPerType, includeNextGenZaps],
    (signal) => {
      // Named rather than spread from the enum, which would auto-subscribe
      // opted-in hosts to whatever type is added next.
      const assetTypes = includeNextGenZaps
        ? ([...defaultAssetTypes, "nextGenZap"] as const)
        : undefined;

      return fetchAssetSearch(query, limitPerType, assetTypes, signal);
    },
    { enabled: query !== "" },
  );
}
